const parseStatementDate = (value) => {
  if (!value) return null;
  const firestoreDate = value?.toDate?.() || (
    typeof value?.seconds === "number" ? new Date(value.seconds * 1000) : null
  );
  if (firestoreDate) return Number.isNaN(firestoreDate.getTime()) ? null : firestoreDate;
  const text = String(value).trim();
  const dateOnlyMatch = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  const date = dateOnlyMatch
    ? new Date(Number(dateOnlyMatch[1]), Number(dateOnlyMatch[2]) - 1, Number(dateOnlyMatch[3]))
    : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const statementDateParts = (value) => {
  const date = parseStatementDate(value);
  if (!date) return { date: String(value || ""), time: "" };
  const sourceText = typeof value === "string" ? value.trim() : "";
  const sourceIsDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(sourceText) ||
    /T00:00:00(?:\.\d+)?Z$/i.test(sourceText);
  const formattedTime = date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
    timeZone: "Europe/London",
  });
  return {
    date: date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      timeZone: "Europe/London",
    }),
    time: sourceIsDateOnly ? "" : formattedTime,
  };
};

export const formatStatementDateOnly = (value) =>
  statementDateParts(value).date;

export const formatStatementDate = (value) => {
  const parts = statementDateParts(value);
  return [parts.date, parts.time].filter(Boolean).join(" ");
};
